import { FC } from "react";
import { useResourceRegister } from "@/utils/resourceRegister";

const BackupResourceRegister: FC = () => {
  useResourceRegister({ name: 'backups-n-validations/list' })
  useResourceRegister({ name: 'database-types' })
  useResourceRegister({ name: 'database-engine-versions' })
  useResourceRegister({ name: 'validation-schedule' })
  
  return (
    null
  )
}

export default BackupResourceRegister;
